import {createApp} from 'vue'
import App from './App.vue'
import {globalMixin} from '@/mixins/mixins'
import {registerComponents} from "@/global-config/component/component-registration/register-components";
import router from "@/global-config/router/routes-registration/route";
// import Toaster from "@meforma/vue-toaster";
import { defineRule, configure } from "vee-validate";
import * as rules from '@vee-validate/rules';
import "./global-config/validator/locales";
import store from "@/global-config/store/store";
import Toast, { POSITION,TYPE } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";


// Make the validator aggressive to show case validators
configure({
    validateOnInput: true
});
Object.keys(rules).forEach(rule => {
    defineRule(rule, rules[rule]);
});

defineRule('cardMaxLength', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
        return true;
    }

    if (value.length > limit) {
        return `The cardNumber field may not be greater than 16 characters`;
    }

    return true;
});

defineRule('card', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
        return true;
    }

    var a = /^[0-9\-]+$/;
    if (a.test(value) == true)
    {
        return true
    }
    else
    {
        return `Only numeric characters are allowed`;
    }
});

defineRule('phone', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
        return true;
    }
    // Only allow numeric characters and "+"
    var numericPattern = /^[0-9\+]+$/;
    if (!numericPattern.test(value)) {
        return `Only numeric characters are allowed`;
    }

    // Remove the "+" for further validation (if any)
    var cleaned = value.replace(/\+/g, '');

    // Check if the phone number starts with more than two zeros
    if (/^000+/.test(value)) {
        return `Invalid phone number`;
    }

    // Check the length of the phone number
    if (cleaned.length < 10 || cleaned.length > 15) {
        return `Phone number must be between 10 and 15 digits`;
    }

    // If all checks pass, return true
    return true;
});


const toastification_plugin_options = {
    // toastDefaults: {
    //     // ToastOptions object for each type of toast
    //     [TYPE.ERROR]: {
    //         toastClassName:'saddam32 error',
    //     },
    //     [TYPE.SUCCESS]: {
    //         toastClassName:'saddam success',
    //     }
    // },
    // You can set your default options here
    // transition: {
    //     enter: "fade-enter-active",
    //     leave: "Vue-Toastification__bounce-leave-active",
    //     move: "fade-move"
    // },
    // transitionDuration: {
    //     enter: 1000,
    //     leave: 700
    // },
    // icon: false,
    timeout: 2000,
    position: POSITION.TOP_RIGHT,
    maxToasts: 1,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
            t => t.type === toast.type
        ).length !== 0) {
            // Returning false discards the toast
            return false;
        }
        // You can modify the toast if you want
        return toast;
    }
};

const app = createApp(App)
    .use(router)
    .use(store)
    // .use(Toaster,{
    //     // One of the options
    //     position: "bottom-right",
    //     maxToasts:1,
    //     queue:true,
    //     // duration:false,
    //     // useDefaultCss: false
    // })
    .use(Toast, toastification_plugin_options)


app.mixin(globalMixin)


registerComponents(app);
app.mount("#app");

require('./global-config/router/routes-interceptor/routes-interceptor')
